import { useCallback } from 'react';

import {
  IGeneralRequestResponse,
  IHttpHookResponseAwaitable,
  httpMethods,
  useHttpClientAwaitable,
} from '@services/httpClientService';

import { ApiSectionNamespace } from '../../apiConstants';

import { mappingFunction } from './mapper';
import { ICheckOrderExistsRequest, ICheckOrderExistsResponse } from './model';

export const useCheckOrderExistsOnDemand = (): IHttpHookResponseAwaitable<
  ICheckOrderExistsResponse,
  ICheckOrderExistsRequest
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    ICheckOrderExistsResponse,
    ICheckOrderExistsRequest,
    IGeneralRequestResponse<ICheckOrderExistsResponse>
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EOrderApiKeys.CHECK_ORDER_EXISTS,
    mappingFunction,
  });

  const request = useCallback(
    (data?: ICheckOrderExistsRequest): Promise<ICheckOrderExistsResponse | null> =>
      awaitableRequest({
        data: data,
      }),
    [awaitableRequest],
  );

  return { request };
};
